export default [
    {
        path: '/assemble',
        component: () => import('@/views/assemble/index.vue'),
        meta: {
            title: '集训列表',
        },
    },
    {
        path: '/assemble-details',
        component: () => import('@/views/assemble/assemble-details.vue'),
        meta: {
            title: '集训详情',
        },
    },
]
